import { DEFAULT_CONTACT_PHONE, DEFAULT_SUPPORT_EMAIL } from 'globalConstants';
import Link from 'next/link';
import { converNumericStringToPhoneNumberMaskString } from 'utils/conver-numeric-string-to-phone-number-mask-string';

const LeftSection = () => (
  <div
    id='left-section'
    className='flex h-full min-w-[280px] flex-col items-center justify-between space-y-[52px] bg-[linear-gradient(180deg,_#e9f3ff_0%,_#ffffff_100%)] px-[24px] py-[32px]'
  >
    <Link href='/' className='self-start'>
      <img
        src='/logos/atm-nha-colored.svg'
        alt='ATM Nhà'
        loading='lazy'
        className='h-[40px] w-[132px]'
      />
    </Link>
    <div className='h-[255px] w-[230px] bg-[url("/images/banners/sign-in-banner.svg")] bg-cover bg-center bg-no-repeat' />
    <div className='flex flex-col space-y-[16px]'>
      <span className='text-[16px] font-[600] text-primary'>Gặp vấn đề?</span>
      <div className='flex flex-col'>
        <span>Số điện thoại hỗ trợ:</span>
        <span className='font-[600]'>
          {converNumericStringToPhoneNumberMaskString(DEFAULT_CONTACT_PHONE)}
        </span>
      </div>
      <div className='flex'>
        <span>Email hỗ trợ:</span>
        <span className='font-[600]'>{DEFAULT_SUPPORT_EMAIL}</span>
      </div>
    </div>
  </div>
);

export default LeftSection;
